<template>
  <div>
    <form @submit.prevent="subGroupSearch">
      <div class="inline-search-form external">
        <div class="form-group">
          <label for="subGroupName" v-show="subGroupName.length == 0">Name:</label>
          <input type="text" id="subGroupName" name="subGroupName" ref="subGroupName" value v-model="subGroupName">
        </div>
        <button type="submit" class="btn --sm">Search</button>
      </div>
    </form>

    <app-advanced-table
      title="Subgroup Results"
      :headers="subGroupHeaders"
      id="search-subGroups"
      :items="subGroupsByGroupSelection"
      @cellClicked="subGroupClicked"
      :search="subGroupSearch"
      :rowsPerPage="3"
      :clickable="true"
    >
      <template #items="{ item, visibleHeaders, getCellValue }" >
        <tr>
          <template v-for="(header, index) in visibleHeaders">
            <truncate-concat
              @clicked="subGroupClicked(item)"
              v-if="header.truncate"
              :tabbable="true"
              :maxChars="header.maxChars"
              :key="index"
              :value="getCellValue(item, header)"
              class="-link-style"
              tag="td"
            />
            <td v-else-if="header.value === 'groupDetails'" :key="index">
              <a href="javascript:void(0)" @click.stop="goToSubGroup(item)">View Details</a>
            </td>
            <td v-else-if="header.value === 'select'" :key="index" class="-link-style" @click.stop="subGroupClicked(item)">
              <a href="javascript:void(0)" @click.stop="subGroupClicked(item)">
                Select
              </a>
            </td>
            <td
              v-else-if="header.value === 'terminationDate' || header.value === 'effectiveDate'"
              @click="subGroupClicked(item)"
              :key="index"
            >
              <a href="javascript:void(0)" @click.stop="subGroupClicked(item)">
                {{formatDate(getCellValue(item, header))}}
              </a>
            </td>
            <td
              v-else
              @click="subGroupClicked(item)"
              :key="index"
            >

              <a href="javascript:void(0)" @click.stop="subGroupClicked(item)">
                {{getCellValue(item, header)}}
              </a>
            </td>

          </template>
        </tr>
      </template>
    </app-advanced-table>
  </div>
</template>

<script>
  import AppAdvancedTable from '@organisms/AdvancedTable.vue'
  import groupSelection from '@mixins/groupSelection'
  import formattable from '@mixins/formattable'
  import { mapActions, mapGetters } from 'vuex'
  import TruncateConcat from '@atoms/ConcatAndEllipseValues.vue'

  export default {
    mixins: [groupSelection, formattable],
    components: {
      AppAdvancedTable,
      TruncateConcat
    },
    data() {
      return {
        subGroupName: '',
        subGroupHeaders: [
          {
            text: 'Subgroup',
            align: 'left',
            value: 'subGroup',
            truncate: true,
            maxChars: 55
          },
          { text: 'Effective Date', value: 'effectiveDate' },
          { text: 'Term Date', value: 'terminationDate' },
          { text: 'Subgroup Details', value: 'groupDetails' },
          { text: 'Group', value: 'group', visible: false, truncate: true },
          { text: '', value: 'select', sortable: false },
          { text: 'Group CK', value: 'groupCk', visible: false }
        ]
      }
    },
    methods: {
      ...mapActions('portalContext', {
        subGroupClicked: 'INTERNAL_SELECT_SUB_GROUP'
      })
    },
    computed: {
      ...mapGetters('portalContext', ['subGroupsByGroupSelection']),
      subGroupSearch() {
        return this.subGroupName.trim()
      }
    },
    mounted() {
      this.$refs.subGroupName.focus()
    }
  }
</script>
